<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.procedimentos"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(codigo)="{item}">
                {{formatProcedimento((item.procedimento && item.procedimento.codigo) ? item.procedimento.codigo : item.codigo)}}
            </template>

            <template v-slot:cell(cid)="{item}">
                <span v-if="item.cid">{{ formatCid(item.cid.codigo) }} - {{ item.cid.nome }}</span>
                <span v-else>-</span>
            </template>

            <template v-slot:cell(quantidade)="{item}"> 
                {{ item.quantidade != null ? item.quantidade : ' - ' }}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                    :disabled="data.visualizarModo"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                    :disabled="data.visualizarModo"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            :ferida-model="feridaModel"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import {formats, repository} from '@/mixins'

// Vuex
import {mapActions} from 'vuex'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'codigo', label: 'Código', sortable: true},
            {key: 'procedimento.nome', label: 'Nome', sortable: true},
            {key: 'cid', label: 'CID', sortable: true},
            {key: 'quantidade', label: 'Qtd.', sortable: true, class: 'text-center'},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    created() {
        this.repositories = {
            atendimento: this.getConectaSusRepository('ambulatorio.atendimentoEnfermagem'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', async () => {
                
                const item = this.data.procedimentos[index]

                if (item.id) {
                    this.setLoading()
                    this.repositories.atendimento.destroyFeridaProcedimento(item.id)
                        .then(() => {
                            this.data.procedimentos.splice(index, 1)
                            this.$emit('change')
                            this.showSuccessNotification('Procedimento excluído com sucesso.')
                        })
                        .catch(this.handleError)
                        .finally(this.unsetLoading)
                } else {
                    this.data.procedimentos.splice(index, 1)
                    this.$emit('change')
                }
            })
        },
    },
    mixins: [formats, repository],
    props: {
        data: {type: Object, required: true},
        feridaModel: {type: Object},
    },
}
</script>